<!-- @format -->
<script lang="ts">
    import { getStoresContext } from "~/stores";
    import type { StoresKey } from "~/stores";
    import { normalizeURL } from "~/util/store";

    export let request_store_key: StoresKey;
    const { store, T } = getStoresContext(request_store_key);


    $: t = $T;
    $: homepage = normalizeURL($store?.homepage, 'http');
    $: email = normalizeURL($store?.email, 'email');
    $: phone = normalizeURL($store?.phone, 'tel');

</script>


    <div class="contact-info-wrapper right-inner-wrapper mt-3 mt-lg-0 mx-3 mx-lg-0">
        <div class="right-inner-title">{t`contact-information`}</div>
        <div class="right-inner-description">
            {#if phone.href}
                <a href="{phone.href}" class="d-block link mb-1">{phone.text}</a>
            {/if}
            {#if email.href}
                <a href="{email.href}" class="d-block link mb-1">{email.text}</a>
            {/if}
            {#if homepage}
                <a href={homepage.href} class="fw-bold d-block mb-1 link homepage" target="_blank">
                {homepage.text}
                </a>
            {/if}
            {#if $store?.floor?.description}
                {t`location`} {$store.floor.description}
            {/if}
        </div>
    </div>

<style lang="scss">
    .right-inner-wrapper {
        text-align: center;
        margin-bottom: 60px;
        padding: 0 20%;
        @media screen and (max-width: 991px) {
            text-align: left;
            padding: 0;
        }
        a {
            text-decoration: none;
            word-wrap: break-word;
        }
        a.homepage {
            color: var(--color-accent-primary-text);
        }
        .right-inner-title {
            font-size: 1.2rem;
            margin-bottom: 10px;
        }
    }
</style>